import { render, staticRenderFns } from "./NewCampaignPopup.vue?vue&type=template&id=61cc56ba&scoped=true"
import script from "./NewCampaignPopup.vue?vue&type=script&lang=js"
export * from "./NewCampaignPopup.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=61cc56ba&prod&scoped=true&lang=css&external"
import style1 from "@/assets/styles/cms-commercial.css?vue&type=style&index=1&id=61cc56ba&prod&scoped=true&lang=css&external"
import style2 from "./NewCampaignPopup.vue?vue&type=style&index=2&id=61cc56ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cc56ba",
  null
  
)

export default component.exports